// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BranchesOutlinedSvg from "@ant-design/icons-svg/es/asn/BranchesOutlined";
import AntdIcon from '../components/AntdIcon';

var BranchesOutlined = function BranchesOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: BranchesOutlinedSvg
  }));
};

BranchesOutlined.displayName = 'BranchesOutlined';
export default React.forwardRef(BranchesOutlined);